import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { Actions, Store, ofActionSuccessful } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Survey } from 'src/app/models/survey';
import { LoadSurveysSuccess, SurveysState } from '../../../redux';
import { ViewSurveyComponent } from '../view-survey.component';

@Component({
  selector: 'app-modal-container-survey',
  template: ''
})
export class ModalContainerSurveyComponent implements OnDestroy, OnInit {
  public survey$: Observable<Survey[] | undefined> = inject(Store).select(SurveysState.surveys);
  private unsubscribe = new Subject<void>();

  public tableData?: Survey[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: NbDialogService,
    private actions$: Actions
  ) {}

  public ngOnInit() {
    this.survey$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.tableData = data));
    this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe((params) => {
      if (this.tableData) {
        const found = this.tableData.find((element) => element.survey_id === params.id);
        if (found) {
          this.dialogService
            .open(ViewSurveyComponent, {
              closeOnEsc: false,
              closeOnBackdropClick: false,
              context: {
                survey: Survey.copy(found)
              }
            })
            .onClose.subscribe(() => {
              this.router.navigateByUrl('surveys/table');
            });
        } else {
          this.router.navigateByUrl('surveys/table');
        }
      } else {
        this.actions$.pipe(ofActionSuccessful(LoadSurveysSuccess), takeUntil(this.unsubscribe)).subscribe(() => {
          const found = this.tableData.find((element) => element.survey_id === params.id);
          if (found) {
            this.dialogService
              .open(ViewSurveyComponent, {
                closeOnEsc: false,
                closeOnBackdropClick: false,
                context: {
                  survey: Survey.copy(found)
                }
              })
              .onClose.subscribe(() => {
                this.router.navigateByUrl('surveys/table');
              });
          } else {
            this.router.navigateByUrl('surveys/table');
          }
        });
      }
    });
  }

  public ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
